<template>
    <span>
        <svg t="1597399243153" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1793"
             :width="width"
             :height="height" @click="$emit('click')">
            <path :style="{fill:color }"
                  d="M352.4 801.6c-16.5 0-29.5-13.4-29.5-29.5v-44.5c0-16.5 13.4-29.5 29.5-29.5 16 0 29.5 13.4 29.5 29.5v44.5c0 16.1-13 29.5-29.5 29.5z m0 0M669.9 801.6c-16.5 0-29.5-13.4-29.5-29.5v-44.5c0-16.5 13.4-29.5 29.5-29.5 16 0 29.5 13.4 29.5 29.5v44.5c-0.1 16.1-13 29.5-29.5 29.5z m0 0"
                  p-id="1794"></path>
            <path :style="{fill:color }"
                  d="M511.4 959.6c-60.3 0-118.8-11.8-174-35.1-53.2-22.5-101-54.7-142-95.8-41-41-73.2-88.8-95.8-142-23.3-55.2-35.1-113.7-35.1-174s11.8-118.8 35.1-173.9c22.5-53.2 54.7-101 95.8-142s88.8-73.2 142-95.8c55.1-23.3 113.6-35.1 174-35.1S630.2 77.7 685.3 101c53.2 22.5 101 54.7 142 95.8 41 41 73.2 88.8 95.8 142 23.3 55.1 35.1 113.6 35.1 173.9s-11.8 118.8-35.1 173.9c-22.5 53.2-54.7 101-95.8 142-41 41-88.8 73.2-142 95.8-55.1 23.3-113.6 35.2-173.9 35.2z m0-837c-215.1 0-390.1 175-390.1 390.1 0 215.1 175 390.1 390.1 390.1s390.1-175 390.1-390.1c-0.1-215.1-175-390.1-390.1-390.1z"
                  p-id="1795"></path>
            <path :style="{fill:color }"
                  d="M731.4 490.3l26.4-81.2c4.7-14-1.6-29-14.5-35.7l-76-38.8-38.8-76c-6.7-12.9-21.7-19.1-35.7-14.5l-81.2 26.4-81.2-26.4c-14-4.7-29 1.6-35.7 14.5l-39.3 75.5-76 38.8c-12.9 6.7-19.1 21.7-14.5 35.7l26.4 81.2L265 571c-4.7 14 1.5 29 14.5 35.7l76 38.8 38.8 76C401 734.4 416 740.6 430 736l81.2-26.4 81.2 26.4c3.1 1 6.2 1.5 9.3 1.5 10.9 0 21.2-5.7 26.9-15.5l38.8-76 76-38.8c12.9-6.7 19.1-21.7 14.5-35.7l-26.5-81.2z m-101.8-36.7L505 578.2c-0.2 0.2-0.3 0.4-0.5 0.6l-0.1 0.1c-10.1 10.1-26.7 10.1-36.8 0l-74.5-74.5c-10.1-10.1-10.1-26.7 0-36.8l0.1-0.1c10.1-10.1 26.7-10.1 36.8 0l56 56 106.8-106.8c10.1-10.1 26.7-10.1 36.8 0l0.1 0.1c10.1 10.1 10.1 26.7-0.1 36.8z"
                  p-id="1796"></path>
            <path :style="{fill:color }"
                  d="M679.4 490.3l20.1-62c3.6-10.7-1.2-22.1-11.1-27.2l-58-29.6-29.6-58c-5.1-9.9-16.6-14.6-27.2-11.1l-62 20.1-62-20.1c-10.7-3.6-22.1 1.2-27.2 11.1l-30 57.6-58 29.6c-9.9 5.1-14.6 16.6-11.1 27.2l20.1 62-20.1 62c-3.6 10.7 1.2 22.1 11.1 27.2l58 29.6 29.6 58c5.1 9.9 16.6 14.6 27.2 11.1l62-20.1 62 20.1c2.4 0.8 4.7 1.2 7.1 1.2 8.3 0 16.2-4.3 20.5-11.8l29.6-58 58-29.6c9.9-5.1 14.6-16.6 11.1-27.2l-20.1-62.1z m-49.8-36.7L505 578.2c-0.2 0.2-0.3 0.4-0.5 0.6l-0.1 0.1c-10.1 10.1-26.7 10.1-36.8 0l-74.5-74.5c-10.1-10.1-10.1-26.7 0-36.8l0.1-0.1c10.1-10.1 26.7-10.1 36.8 0l56 56 106.8-106.8c10.1-10.1 26.7-10.1 36.8 0l0.1 0.1c10.1 10.1 10.1 26.7-0.1 36.8z"
                  p-id="1797"></path>
        </svg>
    </span>
</template>

<script>
export default {
  name: "AuthIcon",
  props: {
    success: {type: Boolean, default: false},
    failure: {type: Boolean, default: false},
    warning: {type: Boolean, default: false},
    none: {type: Boolean, default: false},

    height: {type: String, default: '31px'},
    width: {type: String, default: '31px'},
  },
  data: () => ({
    margin: '0 auto',
    display: 'block',
    color: "#bfbfbf",
    //color: "#e16531",
    //color: "#d81e06",
    //color: "#0e932e",
  }),
  mounted() {
    if (this.success) {
      this.color = '#0e932e';
    } else if (this.failure) {
      this.color = '#d81e06';
    } else if (this.warning) {
      this.color = '#e16531';
    }
  },
  watch: {
    'none': 'refreshIcon',
    'success': 'refreshIcon',
    'failure': 'refreshIcon',
    'warning': 'refreshIcon'
  },
  methods: {
    refreshIcon() {
      if (this.none) {
        if (!this.success) {
          this.color = '#bfbfbf';
        }
      } else if (this.success) {
        this.color = '#0e932e';
      } else if (this.failure) {
        this.color = '#d81e06';
      } else if (this.warning) {
        this.color = '#e16531';
      }
    }
  }
}
</script>
<style scoped lang="scss">
</style>